"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"

const ROOT = process.env.NEXT_PUBLIC_ROOT

const fetchClientLifeSentence = () =>
  fetchInterceptorInClient(
    {
      method: "get",
      credentials: "same-origin",
    },
    ROOT,
  )(() => `/api/community/pick/life-sentences`).then(
    resultPostprocessing2<{ id: string }>,
  )
export default fetchClientLifeSentence
